<template>
	<table class="[&_tr+tr>th]:pt-1 [&_tr+tr>td]:pt-1 lg:mr-0">
		<tbody>
			<template v-for="(entity, entityIndex) in processedEntities" :key="entityIndex">
				<template v-if="entity.open">
					<template v-for="(chunk, chunkIndex) in entity.chunks">
						<tr
							v-for="(range, rangeIndex) in chunk[0].hours"
							:key="`${entityIndex}-${chunkIndex}-${rangeIndex}`"
						>
							<template v-if="rangeIndex === 0">
								<th
									v-if="chunkIndex === 0 && !selectedBranchLabelFresh"
									:rowspan="entity.tableRowCount"
									class="font-normal text-left align-top"
									:class="thClass"
									scope="row"
								>
									<NuxtLink
										v-if="(entity.name === 'Hypermarket' && linkedContentHypermarket) || (entity.name !== 'Hypermarket' && linkedContent)"
										:to="entity.fullSlug"
										class="underline text-body-link hover:decoration-transparent"
										@click="handleClick(entity.name)"
									>
										{{ entity.name }}
									</NuxtLink>
									<template v-else>
										{{ entity.name }}
									</template>
								</th>
								<td
									:rowspan="chunk[0].hours.length"
									class="align-top text-left whitespace-nowrap"
									:class="[
										{'text-functional-warning-primary': chunk[0].isHoliday},
										{'pl-4': !selectedBranchLabelFresh}
									]"
								>
									{{ formatChunkDays(chunk, selectedBranchLabelFresh) }}
								</td>
							</template>
							<td
								class="align-top text-right whitespace-nowrap"
								:class="[{'text-functional-warning-primary': chunk[0].isHoliday}, {'pl-3': !selectedBranchLabelFresh}]"
							>
								<template v-if="chunk[0].isOpen">
									{{ formatHourRange(range) }}
								</template>
								<template v-else>
									Zavřeno
								</template>
							</td>
						</tr>
					</template>
				</template>
				<template v-else>
					<tr>
						<th
							class="font-normal text-left align-top"
							scope="row"
						>
							<NuxtLink
								v-if="(entity.name === 'Hypermarket' && linkedContentHypermarket) || (entity.name !== 'Hypermarket' && linkedContent)"
								:to="entity.fullSlug"
								class="underline text-body-link hover:decoration-transparent"
								@click="handleClick(entity.name)"
							>
								{{ entity.name }}
							</NuxtLink>
							<template v-else>
								{{ entity.name }}
							</template>
						</th>
						<td colspan="2" class="pl-4 align-top text-right text-body-important">
							Zavřeno
						</td>
					</tr>
				</template>
			</template>
		</tbody>
	</table>
</template>

<script lang="ts" setup>
	import {storeToRefs} from 'pinia';
	import {parseOpeningHours, formatHourRange, formatChunkDays, type OpeningHoursEntity} from '~/utils/openingHours';
	import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';

	interface Props {
		entities: readonly OpeningHoursEntity[];
		thClass?: string;
		linkedContent?: boolean;
		linkedContentHypermarket?: boolean;
	}

	type Emits = {
		(e: 'update:click', text: string): void
	};

	const props = defineProps<Props>();
	const emit = defineEmits<Emits>();

	const processedEntities = computed(() => props.entities.map((entity) => ({
		...entity,
		...parseOpeningHours(entity.hours, entity.holidays),
	})));

	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarketInstance} = storeToRefs(hypermarketsStore);
	const selectedBranchLabelFresh = computed(() => selectedHypermarketInstance.value?.branchType === 'fresh');

	function handleClick(text: string) {
		emit('update:click', text);
	}
</script>
